import { cn } from "@u/cn";
import { type ReactNode } from "react";

const COLS = {
  2: "grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-3",
  4: "grid-cols-2 lg:grid-cols-4",
} as const;

export interface DashboardKPIRowProps {
  columns?: 2 | 3 | 4;
  className?: string;
  children: ReactNode;
}

/** Compact responsive row of KPI stats (Revenue, Users, Orders, …). */
export function DashboardKPIRow({
  columns = 4,
  className,
  children,
}: DashboardKPIRowProps) {
  return (
    <div className={cn("grid gap-4", COLS[columns], className)}>{children}</div>
  );
}
